export default __webpack_public_path__ + "static/media/oldMountain_long_black.578a0708.jpg";